import { action, intercept, makeObservable, observable } from 'mobx'
import { IValidationSchema, pattern, required, validationContext } from 'validx'
import { ContactInformation } from '@taxfyle/api-internal/shared/types/contact_info_pb'
import { isValidUsPhoneNumber } from 'utils/validation-utils'
import PhysicalAddressEditorViewModel from './PhysicalAddressEditorViewModel'

export default class ContactInfoEditorViewModel {
  @observable email = ''

  @observable phoneNumber = ''

  readonly physicalAddressVm = new PhysicalAddressEditorViewModel()

  private schema: IValidationSchema<this> = {
    email: [
      required('Email is required'),
      pattern('email', 'Must be a valid email'),
    ],
    phoneNumber: [required('Phone number is required'), isValidUsPhoneNumber()],
  }

  validation = validationContext(this)

  constructor() {
    makeObservable(this)

    intercept(this, (change) => {
      this.validation.clearErrors(String(change.name))
      return change
    })
  }

  @action.bound
  validate() {
    const ownValid = this.validation.reset().validate(this.schema).isValid
    const addressValid = this.physicalAddressVm.validate()
    return ownValid && addressValid
  }

  @action
  reset(info?: ContactInformation.AsObject) {
    this.email = info?.email ?? ''
    this.phoneNumber = info?.phoneNumber ?? ''
    this.physicalAddressVm.reset(info?.address)
    this.validation.reset()
  }

  toContactInfo(): ContactInformation.AsObject {
    return {
      email: this.email,
      phoneNumber: this.phoneNumber,
      address: this.physicalAddressVm.toPhysicalAddress(),
    }
  }
}
